/* eslint-disable jsx-quotes */
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Portal from '../../../Portal/Portal';

import './styles.css';
import { asyncApprovesTests, asyncCorrectionTests, asyncDiscardTest } from '../../tests-conducted.actions';

class ApprovedTestsModalPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            currentFilters,
            handleClickOutPortal,
            data: { name, tcc, status, testId },
        } = this.props;
        return (
            <Portal>
                <section className="portal">
                    <span
                        className="background-container"
                        onClick={handleClickOutPortal}
                    />
                    <div className="container-approved-tests-modal">
                        <span className="header-info">
                            <h1>{name}</h1>
                            <i
                                className="fa fa-times-circle icon"
                                onClick={handleClickOutPortal}
                            />
                        </span>
                        {tcc && (
                            <React.Fragment>
                                <p>
                                    <strong>Coach: </strong>
                                    {tcc.coach_name}
                                </p>
                                <p>
                                    <strong>
                                        Data de conclusão 1º módulo:{' '}
                                    </strong>
                                    {tcc.finish_first_module_date ?
                                        moment(
                                            tcc.finish_first_module_date,
                                        ).format('DD/MM/YYYY')
                                    :
                                        <span>-</span>
                                    }
                                </p>
                                <p>
                                    <strong>
                                        Data de conclusão 2º módulo:{' '}
                                    </strong>
                                    {tcc.finish_second_module_date ?
                                        moment(
                                            tcc.finish_second_module_date,
                                        ).format('DD/MM/YYYY')
                                    :
                                        <span>-</span>
                                    }
                                </p>
                                <p>
                                    <strong>Data de conclusão master: </strong>
                                    {tcc.finish_master_date ?
                                        moment(tcc.finish_master_date).format(
                                            'DD/MM/YYYY',
                                        )
                                        :
                                        <span>-</span>
                                    }
                                </p>
                                <h3>Anexos</h3>
                                <div className="grid-attach-header">
                                    {(tcc.attachments && tcc.attachments.length > 0) 
                                    ?
                                    <React.Fragment>
                                        <span>
                                            <p>Nome</p>
                                        </span>
                                    </React.Fragment>
                                    :
                                    <span>Nenhum anexo adicionado</span>
                                    }
                                </div>
                                {tcc.attachments &&
                                    tcc.attachments.length > 0 &&
                                    tcc.attachments.map(attach => (
                                        <div className="grid-attach">
                                            <a target="_blank" href={attach.url} >
                                                <p>{attach.name}</p>
                                            </a>
                                        </div>
                                    ))}
                            </React.Fragment>
                        )}

                        <br /><br />

                        {(['APPROVED_REVISION', 'WAIT_CORRECTION'].includes(status)) && (
                            <button onClick={()=>{
                                this.props.asyncApprovesTests(testId, currentFilters);
                                handleClickOutPortal();
                            }} className='button-approved' >Aprovar</button>
                        )}

                        <br />

                        {(status === 'APPROVED_REVISION') && (
                            <button onClick={()=>{
                                this.props.asyncCorrectionTests(testId, currentFilters);
                                handleClickOutPortal();
                            }} className='button-correction' >Solicitar Correções</button>
                        )}

                        <br />

                        {(['APPROVED', 'APPROVED_PENDING', 'APPROVED_REVISION', 'WAIT_CORRECTION'].includes(status)) && (
                            <button onClick={()=>{
                                if (window.confirm('Deseja realmente remover este teste?')) {
                                    this.props.asyncDiscardTest(testId, currentFilters);
                                    handleClickOutPortal();
                                }
                            }} className='button-discard' >Remover</button>
                        )}
                    </div>
                </section>
            </Portal>
        );
    }
}

export default connect((state)=>{
    return {}
},{ asyncApprovesTests, asyncCorrectionTests, asyncDiscardTest })(ApprovedTestsModalPresentation)


// WEBPACK FOOTER //
// ./src/components/tests-conducted/modals/ApprovedTestsModal/ApprovedTestsModalPresentation.js